export default "__VITE_ASSET__UWrO9mzc__"